import Api from './loginApi';

const SystemModuleApi = {
  // ── Módulos ──────────────────────────────────────────────────────────────

  /** GET /system-module/full → módulos com menus aninhados (usa JWT para resolver idSystem) */
  getModulesFull(idSystem) {
    return Api.get('/system-module/full', { params: { id_system: idSystem } });
  },

  /** GET /system-module/admin?id_system= → lista módulos (admin) */
  getModulesAdmin(idSystem) {
    return Api.get('/system-module/admin', { params: { id_system: idSystem } });
  },

  /** GET /system-module/metricas → catálogo de métricas de cota [{codigo, descricao, periodoPadrao, unidade}] */
  getMetricas() {
    return Api.get('/system-module/metricas');
  },

  /**
   * GET /system-module/opcoes?cdModulo= → opções que o vínculo do módulo pode contratar [{codigo, descricao}].
   * ATENDIMENTO_WHATSAPP: TRIAGEM, CONSULTAS, AUDIO, IMAGEM e WIKI; outro módulo devolve lista vazia.
   */
  getOpcoes(cdModulo) {
    return Api.get('/system-module/opcoes', { params: { cdModulo } });
  },

  /** POST /system-module → cria um módulo (cd_modulo: código fixo usado pelo sistema, ex.: ATENDIMENTO_WHATSAPP) */
  createModule(data) {
    return Api.post('/system-module', data);
  },

  /** PUT /system-module/:id → atualiza um módulo */
  updateModule(id, data) {
    return Api.put(`/system-module/${id}`, data);
  },

  /** DELETE /system-module/:id → remove um módulo */
  deleteModule(id) {
    return Api.delete(`/system-module/${id}`);
  },

  /**
   * PATCH /system-module/reorder → reordena múltiplos módulos em lote (transação única).
   * items: Array<{ id_modulo: number, nr_ordem: number }>
   */
  reorderModules(items) {
    return Api.patch('/system-module/reorder', items);
  },

  /**
   * POST /system-module/menu → vincula/desvincula um menu a um módulo.
   * Body: { idSystem, idModulo, idMenu, flAtivo }
   */
  saveLink(payload) {
    return Api.post('/system-module/menu', payload);
  },

  // ── Menus ─────────────────────────────────────────────────────────────────

  /** GET /system-menu?id_system= → todos os menus do sistema */
  getSystemMenus(idSystem) {
    return Api.get('/system-menu', { params: { id_system: idSystem } });
  },

  /** POST /system-menu → cria um menu */
  createMenu(data) {
    return Api.post('/system-menu', data);
  },

  /** PUT /system-menu/:id → atualiza um menu */
  updateMenu(id, data) {
    return Api.put(`/system-menu/${id}`, data);
  },

  /** DELETE /system-menu/:id → remove um menu */
  deleteMenu(id) {
    return Api.delete(`/system-menu/${id}`);
  },
};

export default SystemModuleApi;
